import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Intervencion`, method: 'GET', body: null, token: token})
}
